import { ShoppingCartContext } from '@seek/shopping-cart-provider';
import { useContext } from 'react';

export const useShoppingCart = () => {
  const shoppingCartContext = useContext(ShoppingCartContext);

  if (!shoppingCartContext) {
    throw new Error('ShoppingCartContext is not provided');
  }

  return shoppingCartContext;
};

export type ShoppingCartContextProps = React.ContextType<
  typeof ShoppingCartContext
>;
